import React from 'react'
import PanelSearchCnpj from '../search/PanelSearchCnpj'
import TableFinancial from './TableFinancial'

function PanelFinancialCnpj({
  cnpj,
}) {
  return (
    <PanelSearchCnpj 
      cnpj={cnpj}
      TableComponent={TableFinancial} />
  )
}

export default (PanelFinancialCnpj)